// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton_skeleton__+WdmQ","loading":"Skeleton_loading__JoyQZ"};